<template>
  <button
    type="button"
    class="btn btn-success rounded-pill border-0"
    :class="addClass"
    :aria-expanded="ariaExpanded || undefined"
    :aria-controls="ariaControls"
    :aria-labelledby="ariaLabelledby"
    :aria-label="ariaLabelledby"
  >
    <template
      v-if="!plusOnly"
    >
      <i
        class="mi-plus"
        :class="[`icon-${iconSize}px`, { 'block xl:hidden' : !iconNoHide }]"
      />
      <span class="hidden xl:block p-0">{{ t('add_portion') }}</span>
    </template>
    <i
      v-else
      class="mi-plus"
      :class="`icon-${iconSize}px`"
    />
    <span
      v-if="counter > 0"
      class="inline-block p-2 absolute top-0 right-0 mr-n1 bg-warning rounded-circle"
    >
      <span class="absolute centered text-sm text-white leading-1">{{ counter }}</span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps({
  plusOnly: {
    type: Boolean,
    default: true,
  },

  addClass: {
    type: String,
    default: '',
  },

  counter: {
    type: Number,
    default: 0,
  },

  iconSize: {
    type: String,
    default: '16',
  },

  ariaExpanded: {
    type: Boolean,
  },

  ariaControls: {
    type: String,
    default: '',
  },

  ariaLabelledby: {
    type: String,
    default: 'Plus button',
  },

  iconNoHide: {
    type: Boolean,
    default: false,
  },
})
const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "add_portion": "Přidat porci"
},
    "sk": {
    "add_portion": "Pridať porciu"
},
    "pl": {
    "add_portion": "Dodaj porcję"
},
    "hu": {
    "add_portion": "Hozzaadni"
},
    "de": {
    "add_portion": "Hinzufügen"
},
    "at": {
    "add_portion": "Hinzufügen"
},
    "ro": {
    "add_portion": "Adaugă o porție"
}
  }
</i18n>
